namespace Portico.Services {

	import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;

	export interface IDateService {
		add(utcDate: string | Date | moment.Moment, amount: number, unit: string): moment.Moment;
		isAfter(utcDate: string | Date | moment.Moment): boolean;
		isBefore(utcDate: string | Date | moment.Moment): boolean;
		now(): moment.Moment;
		subtract(utcDate: string | Date | moment.Moment, amount: number, unit: string): moment.Moment;
	}

	@Service('app', 'dateService')
	@Inject('$rootScope')
	export class DateService implements IDateService {
		constructor() { }

		add(utcDate: string | Date | moment.Moment, amount: number, unit: string): moment.Moment {
			return moment(utcDate).add(<any>amount, unit);
		}

		isAfter(utcDate: string | Date | moment.Moment): boolean {
			return moment().utc().isAfter(moment(utcDate).utcOffset(0, true));
		}

		isBefore(utcDate: string | Date | moment.Moment): boolean {
			return moment().utc().isBefore(moment(utcDate).utcOffset(0, true));
		}

		now(): moment.Moment {
			return moment().utc();
		}

		subtract(utcDate: string | Date | moment.Moment, amount: number, unit: string): moment.Moment {
			return moment(utcDate).subtract(<any>amount, unit);
		}
	}
}